<div class="medicine" [ngClass]="[data?.medicine, 'total-' + data?.links?.length]">
    <div class="header" *ngIf="data?.logo">
        <div class="image-container">
            <img [src]="data?.logo" [alt]="data?.title" [ngStyle]="data?.logo_dimensions">
        </div>
    </div>

    <div class="body">
        <div class="body-inner">
            <ng-container *ngFor="let link of data?.links">
                <a *ngIf="link.href" [href]="link.href" class="content-link" [target]="link.target ? link.target : '_blank'">
                    <div class="icon">
                        <svg viewBox="0 0 39 39" xmlns="http://www.w3.org/2000/svg"><g><path d="m27.32 26.58a10.49 10.49 0 1 0 -1.4 1.42l6.14 6.4a19.45 19.45 0 1 1 1.46-1.36z"/><path d="m27.65 20a8.38 8.38 0 0 1 -1.73 5.12 8 8 0 0 1 -1.39 1.45 8.48 8.48 0 1 1 3.12-6.57z"/></g></svg>
                    </div>
                    <span [innerHTML]="link.text"></span>
                </a>

                <div *ngIf="!link.href" class="content-link" (click)="contentLinkAction(link)">
                    <div class="icon">
                        <svg viewBox="0 0 39 39" xmlns="http://www.w3.org/2000/svg"><g><path d="m27.32 26.58a10.49 10.49 0 1 0 -1.4 1.42l6.14 6.4a19.45 19.45 0 1 1 1.46-1.36z"/><path d="m27.65 20a8.38 8.38 0 0 1 -1.73 5.12 8 8 0 0 1 -1.39 1.45 8.48 8.48 0 1 1 3.12-6.57z"/></g></svg>
                    </div>
                    <span [innerHTML]="link.text"></span>
                </div>
            </ng-container>
        </div>
    </div>

    <div *ngIf="isiData" class="isi-container" [ngClass]="{'open': isiOpen}">
        <div *ngIf="!hideClose" class="close-isi close-x" (click)="closeIsi()"></div>
        <app-isi [data]="isiData" [scrollable]="isiOpen" [medicine]="data?.medicine"></app-isi>
        <p class="expand-isi" [ngClass]="{'off': isiOpen}" (click)="openIsi()">View More Important Safety Information</p>
    </div>
</div>
